/** Share button: Web Share API on supported devices, clipboard "copy link" fallback. */
import { useState } from 'react';
import { Share2, Check } from 'lucide-react';
import { toast } from '@/components/ui/sonner';

async function copyToClipboard(text) {
	if (navigator.clipboard?.writeText) {
		await navigator.clipboard.writeText(text);
		return;
	}
	// Legacy fallback for insecure contexts / older browsers.
	const ta = document.createElement('textarea');
	ta.value = text;
	ta.style.position = 'fixed';
	ta.style.opacity = '0';
	document.body.appendChild(ta);
	ta.select();
	document.execCommand('copy');
	document.body.removeChild(ta);
}

export function ShareButton({ title, text, url, testId = 'event-share-button' }) {
	const [copied, setCopied] = useState(false);
	const shareUrl = url || (typeof window !== 'undefined' ? window.location.href : '');

	const onShare = async () => {
		const data = { title, text: text || title, url: shareUrl };
		if (navigator.share) {
			try {
				await navigator.share(data);
				return;
			} catch (e) {
				if (e?.name === 'AbortError') return; // user cancelled — do nothing
			}
		}
		try {
			await copyToClipboard(shareUrl);
			setCopied(true);
			toast.success('Link copiato negli appunti');
			setTimeout(() => setCopied(false), 2000);
		} catch {
			toast.error('Impossibile copiare il link');
		}
	};

	return (
		<button
			type="button"
			data-testid={testId}
			onClick={onShare}
			className="inline-flex items-center gap-2 rounded-full border border-slate-700 bg-slate-900/60 px-4 py-2 text-sm font-semibold text-slate-200 transition-colors hover:border-emerald-400/40 hover:text-emerald-300"
		>
			{copied ? <Check size={15} className="text-emerald-300" /> : <Share2 size={15} />}
			{copied ? 'Link copiato' : 'Condividi'}
		</button>
	);
}
